import { Component, ViewChild, TemplateRef, OnDestroy, AfterViewInit, OnInit } from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { AuthService } from "../../services/auth.service";
import { IBusinessFunction } from "../../interfaces/ibusinessfunction";
import { DisclaimerService } from "../../services/disclaimer.service";

@Component({
    selector: "disclaimer",
    templateUrl: "./disclaimer.component.html",
    standalone: false
})
export class DisclaimerComponent implements OnDestroy, AfterViewInit, OnInit {
    @ViewChild("disclaimer") disclaimerModal!: TemplateRef<any>;
    modalInstance!: BsModalRef;
    businessFunction: IBusinessFunction | null;
    disclaimerAccepted: boolean = false;

    constructor(private disclaimerService: DisclaimerService,
        private modalService: BsModalService,
        private authService: AuthService) {
        this.businessFunction = AuthService.businessFunction;
    }

    ngOnInit(): void {
        this.authService.businessFunctionAnnounced$.subscribe((bf: IBusinessFunction) => {
            this.businessFunction = bf;
        });
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.modalInstance = this.modalService.show(this.disclaimerModal, { ignoreBackdropClick: true });
        }, 1000);
    }

    ngOnDestroy(): void {
        if (this.modalInstance) {
            this.modalInstance.hide();
        }
    }
    /**
     * get called on button accept clicked
     */
    onAcceptedClicked(): void {
        if (this.businessFunction?.defaultRoute) {
            this.disclaimerService.setConsentForBusinessFunction(this.businessFunction.defaultRoute);
        }
        this.modalInstance.hide();
    }
}

